export const SET_INITIALISED = 'app/SET_INITIALISED';

export const SET_LOADING = 'app/SET_LOADING';

export const SET_DATA = 'app/SET_DATA';

export const SET_BASEPATH = 'app/SET_BASEPATH';

export const ADD_TO_HISTORY = 'app/ADD_TO_HISTORY';

export const SET_ERROR = 'app/SET_ERROR';

export const SET_COUNTRY = 'app/SET_COUNTRY';

export const SET_SELECTED_BIKE_TYPES = 'app/SET_SELECTED_BIKE_TYPES';

export const SET_DISTANCE = 'app/SET_DISTANCE';

export const SET_QUERY = 'app/SET_QUERY';

export const SET_DEALERS_DATA = 'app/SET_DEALERS_DATA';

export const SET_LISTVIEW = 'app/SET_LISTVIEW';

export const SET_PLACE = 'app/SET_PLACE';

export const SET_COUNTRIES = 'app/SET_COUNTRIES';

export const SET_BIKE_TYPES = 'app/SET_BIKE_TYPES';

export const SET_LAT_LNG = 'app/SET_LAT_LNG';

export const SET_ALL_DEALERS = 'app/SET_ALL_DEALERS';

export const SET_LOCATION_ERROR = 'app/SET_LOCATION_ERROR';
